import moment from 'moment'
import React, { CSSProperties, useEffect, useMemo, useState } from 'react'
import { connect } from 'react-redux'
import { useParams } from 'react-router'
import { Button, Grid, Header, Icon, Image, Input, InputOnChangeData, Label, List, Popup } from 'semantic-ui-react'
import sort from '../../../../assets/svg/act_cluster.svg'
import filter from '../../../../assets/svg/act_filter.svg'
import filter_delete from '../../../../assets/svg/act_filter_delete.svg'
import list from '../../../../assets/svg/act_list_view.svg'
import list_active from '../../../../assets/svg/act_list_view_active.svg'
import timeline from '../../../../assets/svg/act_timeline_view.svg'
import timeline_active from '../../../../assets/svg/act_timeline_view_active.svg'
import add_new from '../../../../assets/svg/add_new.svg'
import search from '../../../../assets/svg/search_icon.svg'
import DatepickerComponent from '../../../../components/Datepicker/Datepicker'
import { ContentHeader } from '../../../../components/Header/ContentHeader'
import { useStateFromProp } from '../../../../hooks/useStateFromProps'
import { RootState } from '../../../../store/rootState'
import { IRouteParams } from '../../../../types/routeParams'
import { IUserDetail } from '../../../../types/user'
import { checkRole, checkTeamMemberOrAdminStatus } from '../../../../utils/checkRole'
import * as ActivityActions from '../../actions/activitiesActions'
import * as ProjectActions from '../../actions/projectActions'
import { _initialActivity } from '../../reducers/activitiesReducer'
import { getClusteredActivitiesSelector, getFilterCountSelector } from '../../selectors/activitiesSelector'
import { IActivityFilter, IActivityFilterOption, IActivitySearch } from '../../types/activityFilters'
import { IProject, ViewType } from '../../types/project'
import { IProjectActivity, IProjectActivityClustering, IProjectActivitySortColumn, IProjectActivitySorting } from '../../types/projectActivity'
import DirectAndPassTroughCostsHeaderContainer from './DirectAndPassTroughCostsHeaderContainer'


interface StateProps {
  project: IProject
  viewType: ViewType
  actFilters: IActivityFilter[]
  sortActivities: IProjectActivitySorting
  filterCount: number
  searchActivitiesValue: IActivitySearch
  acts: IProjectActivity[]
  clusteredActs: IProjectActivityClustering[] | undefined
  selectedActivity: IProjectActivity
  user: IUserDetail | null
}

interface DispatchProps {
  setActFilters: (actFilter: IActivityFilter, queryOptions: IActivityFilterOption) => void
  setViewType: (viewType: ViewType) => void
  searchActivities: (filter: IActivitySearch) => void
  sortActs: (sorting: IProjectActivitySorting) => void
  getActFilters: (id: string | number) => void
  clearActFilters: () => void
  setSelectedActivity: (activity: IProjectActivity) => void
  setOpenActDetailsModal: (open: boolean) => void
  exportProjectActivities: (projectId: number, params: Record<string, string>) => void
}

type Props = StateProps & DispatchProps


const ProjectActivitiesHeader = (props: Props): JSX.Element => {

  const {
    project, viewType, setViewType,
    searchActivities, sortActs, setSelectedActivity,
    sortActivities, actFilters, searchActivitiesValue,
    getActFilters, setActFilters, setOpenActDetailsModal,
    filterCount, clearActFilters, acts, clusteredActs, selectedActivity,
    user, exportProjectActivities
  } = props

  const [open, setOpen] = useState(false)
  const [timer, setTimer] = useState<number>(0)
  const [searchLoading, setSearchLoading] = useState(false)
  const [searchQuery, setSearchQuery] = useStateFromProp(searchActivitiesValue.search ? searchActivitiesValue.search : '')
  const [actFiltersState, setActFiltersState] = useStateFromProp(actFilters)

  const param: IRouteParams = useParams()

  useEffect(() => {
    getActFilters(param.id)
  }, [getActFilters, param.id])

  useEffect(() => {
    if (acts.length !== 0 && selectedActivity.id !== '') {
      const _departmentsOptions: IActivityFilterOption[] = []
      // find updated departments
      acts.forEach(act => {
        if (act.department) {
          _departmentsOptions.push({ value: act.department.id.toString(), name: act.department.name, selected: false })
        }
      })
      // remove duplicate department options from originaly pushed array
      const _filteredDepartmentsOptions: IActivityFilterOption[] = _departmentsOptions.filter(
        (thing, i, arr) => arr.findIndex(t => t.value === thing.value) === i)
      // add updated employees and departments to filter options
      const _filters = actFilters.map(filter => {
        if (filter.name === 'Departments') {
          filter.options = _filteredDepartmentsOptions
        }
        return filter
      })
      setActFiltersState(_filters)
    }
  }, [actFilters, acts, setActFiltersState, selectedActivity])

  const filteredActs = useMemo(() => {
    return clusteredActs?.flatMap(acts => acts.activities).length
  }, [clusteredActs])


  const filterOnClick = (actFilter: IActivityFilter, queryOptions: IActivityFilterOption) => {
    setActFilters(actFilter, queryOptions)
  }

  const handleClearFilters = () => {
    clearActFilters()
  }

  const handleViewTypeChange = (active: 'list' | 'timeline') => {
    if (viewType !== active) {
      setViewType(active)
    }
  }

  const onInputClick = () => {
    if (open) {
      setOpen(false)
    } else {
      setOpen(true)
    }
  }

  const changeDates = (dates: [Date, Date], actFilter: IActivityFilter, queryOptions: IActivityFilterOption) => {
    const [start, end] = dates
    const _queryOptions: IActivityFilterOption = { ...queryOptions, 'start_date': start, 'end_date': end }
    setActFilters(actFilter, _queryOptions)
    if (end) {
      setOpen(false)
    }
  }

  const leftItems = () => {
    return (
      <div style={{ display: 'flex', gap: '8px' }}>
        <Image
          src={viewType === 'list' ? list_active : list}
          onClick={() => handleViewTypeChange('list')}
          style={{ width: '32px', cursor: 'pointer' }}
        />
        <Image
          src={viewType === 'timeline' ? timeline_active : timeline}
          onClick={() => handleViewTypeChange('timeline')}
          style={{ width: '32px', cursor: 'pointer' }}
        />
      </div>
    )
  }

  const renderFilterDropdown = () => {
    return (
      <Grid columns='4' style={{ maxHeight: '30rem' }}>
        <Grid.Row>
          <Grid.Column as='h5' width='2'>
            Filter
          </Grid.Column>
          <Grid.Column width='10' verticalAlign='bottom'>
            <Header.Subheader style={{ fontSize: '0.85rem', colo: '#747678' }}>Active filter contains {filteredActs} of {acts.length} tasks</Header.Subheader>
          </Grid.Column>
          <Grid.Column width='4' verticalAlign='bottom'>
            <Header.Subheader onClick={handleClearFilters} style={{ cursor: 'pointer', fontSize: '0.85rem', color: '#BEC8C3' }}>Clear selection</Header.Subheader>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          {actFiltersState.map(filter => {
            let _listStyle: CSSProperties = { overflowX: 'hidden' }
            const _colStyle: CSSProperties = { width: '24%' }
            if (filter.name === 'Members' || filter.name === 'Departments') {
              _listStyle = { ..._listStyle, overflowY: filter.options.length > 5 ? 'scroll' : 'hidden', height: '12rem' }
              _colStyle.width = filter.name === 'Members' ? '27%' : '25%'
            }
            return (
              <Grid.Column key={filter.name} style={_colStyle}>
                <Header style={{ fontSize: '1rem' }}>{filter.name}</Header>
                <List style={_listStyle}>
                  {filter.options.map((q) => {
                    if (q.value === 'individual') {
                      return (
                        <List.Item key={q.name}>
                          <Label style={{ color: '#232C58', fontWeight: 400, width: '100%', background: q.selected ? '#CDF7EC' : '#F3F3F3' }} as='a'>
                            <DatepickerComponent
                              open={open}
                              onInputClick={() => onInputClick()}
                              onChange={dates => changeDates(dates as [Date, Date], filter, q)}
                              startDate={q.start_date ? moment(q.start_date).toDate() : null}
                              endDate={q.end_date ? moment(q.end_date).toDate() : null}
                              selectsRange={true}
                              dateFormat='yyyy-MM-dd'
                              customInput={<div><p>{q.name}</p></div>}
                              onClickOutside={() => setOpen(false)}
                            />
                          </Label>
                        </List.Item>
                      )
                    }
                    return (
                      <List.Item
                        key={q.name}
                        onClick={() => filterOnClick(filter, q)}
                      >
                        <Label style={{ color: '#232C58', fontWeight: 400, width: '100%', background: q.selected ? '#CDF7EC' : '#F3F3F3' }} as='a'>{q.name}</Label>
                      </List.Item>
                    )
                  })}
                </List>
              </Grid.Column>
            )
          })}
        </Grid.Row>
      </Grid>
    )
  }

  const handleAddTask = () => {
    setSelectedActivity(_initialActivity)
    setOpenActDetailsModal(true)
  }

  const renderSortDropdown = () => {
    return (
      <List>
        <List.Item content={'Phase'} onClick={e => handleSortSelect(e, 'phase')} style={{ cursor: 'pointer', backgroundColor: sortActivities.clustering === 'phase' ? '#CEF7EC' : '', padding: '5px 0 0 5px', width: '8.56rem', height: '1.71rem', borderRadius: '4px' }} />
        <List.Item content={'Department'} onClick={e => handleSortSelect(e, 'department')} style={{ cursor: 'pointer', backgroundColor: sortActivities.clustering === 'department' ? '#CEF7EC' : '', padding: '5px 0 0 5px', width: '8.56rem', height: '1.71rem', borderRadius: '4px' }} />
        <List.Item content={'Completion'} onClick={e => handleSortSelect(e, 'completion')} style={{ cursor: 'pointer', backgroundColor: sortActivities.clustering === 'completion' ? '#CEF7EC' : '', padding: '5px 0 0 5px', width: '8.56rem', height: '1.71rem', borderRadius: '4px' }} />
        <List.Item content={'Overall'} onClick={e => handleSortSelect(e, 'overall')} style={{ cursor: 'pointer', backgroundColor: sortActivities.clustering === 'overall' ? '#CEF7EC' : '', padding: '5px 0 0 5px', width: '8.56rem', height: '1.71rem', borderRadius: '4px' }} />
      </List>
    )
  }

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
    clearTimeout(timer)
    const _timer = window.setTimeout(() => {
      setSearchLoading(false)
    }, 300)
    searchActivities({ search: data.value })
    setTimer(_timer)
    setSearchLoading(true)
    setSearchQuery(data.value)
  }

  const handleClearSearch = () => {
    searchActivities({ search: '' })
    setSearchQuery('')
  }

  const renderSearchIcon = () => {
    if (searchQuery === '') {
      return <Image src={search} style={{ left: '-100%', top: '-2%', padding: '0.5rem' }} />
    }
    return <Icon name='close' link={true} onClick={handleClearSearch} />
  }


  const handleSortSelect = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, _sort: IProjectActivitySorting['clustering']) => {
    sortActs({ clustering: _sort, column: {} as IProjectActivitySortColumn })
  }

  const handleOptionSelect = (key: string) => {
    if (key === 'export') {
      exportProjectActivities(+project.id, { type: 'csv' })
    }
  }

  const renderAdditionalDropdown = () => {
    return (
      <List style={{ width: '5.2rem' }}>
        <List.Item content='Export CSV' onClick={() => handleOptionSelect('export')} style={{ cursor: 'pointer' }} />
      </List>
    )
  }

  const renderExportButton = () => {
    return (
      <Popup
        trigger={
          <Button
            size='small'
            secondary={true}
            icon={<Icon name='ellipsis horizontal' style={{ fontSize: '1.2rem' }} />}
            style={{ padding: '0', borderRadius: '8px', width: '2.3rem', height: '2.3rem', backgroundColor: '#232C58' }}
          />
        }
        style={{ marginLeft: '0.5rem' }}
        content={renderAdditionalDropdown()}
        on='click'
        position='bottom left'
      />
    )
  }

  const renderAddTaskButton = () => {
    if (project.active && user && checkRole(user, [15]) && checkTeamMemberOrAdminStatus(user, project)) {
      return (
        <Image
          src={add_new}
          style={{ width: '32px', cursor: 'pointer' }}
          onClick={handleAddTask}
        />
      )
    }
  }

  const rightItems = () => {
    return (
      <React.Fragment>
        <Input
          loading={searchLoading}
          className='search-input-medium'
          size='small'
          style={{ width: '170px', height: '32px' }}
          icon={renderSearchIcon()}
          iconPosition='left'
          placeholder='Search'
          onChange={(e, data) => handleSearch(e, data)}
          value={searchQuery}
        />
        <div style={{ display: 'flex', gap: '8px', marginLeft: '8px' }}>
          {viewType === 'list' && <Popup
            basic
            trigger={
              <Image
                src={sort}
                style={{ width: '32px', cursor: 'pointer' }}
              />
            }
            content={renderSortDropdown()}
            on='click'
            position='bottom right'
          />}
          <Popup
            basic
            trigger={
              <Button
                primary={filterCount !== 0}
                secondary={filterCount === 0}
                content={
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '2px' }}>
                    <Image
                      size='mini'
                      src={filter}
                      style={{ width: '18px' }}
                    />
                    {filterCount > 0 &&
                      <Label
                        style={{
                          fontSize: '12px',
                          color: '#08D6A1',
                          background: '#FFF',
                          borderRadius: '8px',
                          height: '18px',
                          width: '29px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                        as='a'>
                        {filterCount}
                        <Image
                          src={filter_delete}
                          onClick={handleClearFilters}
                          style={{ width: '7px', height: '7px', cursor: 'pointer' }}
                        />
                      </Label>}
                  </div>
                }
                style={{ width: filterCount > 0 ? '69px' : '32px', height: '32px', borderRadius: '8px', padding: 'initial', margin: 0, backgroundColor: '#232C58' }}
              />
            }
            content={renderFilterDropdown()}
            on='click'
            position='bottom left'
            wide='very'
          />
          {viewType === 'list' && renderExportButton()}
          {viewType === 'list' && renderAddTaskButton()}
        </div>
      </React.Fragment>
    )
  }

  const renderHeaderByProjectType = () => {
    if (project.type === 'service_provider') {
      return <DirectAndPassTroughCostsHeaderContainer />
    } else {
      return (
        <ContentHeader
          id='projectActivitiesHeader'
          title={project.name}
          color='#08D6A1'
          subtitle={project.customer?.name ?? project.category}
          leftItems={leftItems()}
          rightItemsFirst={rightItems()}
          backTitle='Activities'
          backLocation='/projects'
        />
      )
    }
  }

  return renderHeaderByProjectType()
}

const mapStateToProps = (state: RootState): StateProps => {
  return {
    project: state.projectsState.project,
    viewType: state.projectsState.projectPlannerViewType,
    searchActivitiesValue: state.projectsState.searchActivities,
    actFilters: state.projectsState.actFilters,
    sortActivities: state.projectsState.sortActs,
    filterCount: getFilterCountSelector(state),
    acts: state.projectsState.activities,
    clusteredActs: getClusteredActivitiesSelector(state),
    selectedActivity: state.projectsState.selectedActivity,
    user: state.authState.user
  }
}

const mapDispatchToProps = (
  dispatch: ActivityActions.ActivitiesThunkDispatchType & ProjectActions.ProjectThunkDispatchType
): DispatchProps => {
  return {
    setActFilters: (actFilter, queryOptions) => dispatch(ActivityActions.setActFilters(actFilter, queryOptions)),
    setViewType: viewType => dispatch(ProjectActions.setProjectViewType(viewType)),
    searchActivities: filter => dispatch(ActivityActions.searchActivities(filter)),
    sortActs: sorting => dispatch(ActivityActions.sortActs(sorting)),
    getActFilters: id => dispatch(ActivityActions.getActFilters(id)),
    clearActFilters: () => dispatch(ActivityActions.clearActFilters()),
    setSelectedActivity: activity => dispatch(ActivityActions.setSelectedActivity(activity)),
    setOpenActDetailsModal: (open) => dispatch(ActivityActions.setOpenActDetailsModal(open)),
    exportProjectActivities: (projectId, params) => dispatch(ProjectActions.exportProjectActivities(projectId, params)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectActivitiesHeader)
